import { createStyles, FormHelperText, withStyles } from '@material-ui/core';
import styled from 'styled-components';
import { colorUsage, fontWeight } from 'stylesheet';
export var Keyword = styled.span.withConfig({
  displayName: "YTGInputFieldstyle__Keyword",
  componentId: "sc-17iklhh-0"
})(["font-weight:", ";"], fontWeight.bold);
var FormHelperTextOverride = createStyles(function () {
  return {
    root: {
      color: colorUsage.message.warning
    }
  };
});
export var FormHelperTextWarning = withStyles(FormHelperTextOverride)(FormHelperText);